/* eslint-disable camelcase */
import React from 'react';
import styled from 'styled-components';

import { Typography } from '@material-ui/core';

import IconNature from '../../../assets/icon-nature.svg';
import TableDefault from '../../common/TableDefault';
import { formatNumberToUnit } from '../../../utils/formatNumbers';

const Root = styled.div`
	h3 {
		margin-bottom: 40px;
		font-size: 20px;
		font-weight: bold;
	}

	h6 {
		font-size: 16px;
		font-weight: bold;
	}

	img {
		width: 100px;
		margin: 0 10%;
	}

	p {
		margin-top: 20px;
		font-size: 14px;
	}

	.modal-content {
		display: flex;
		max-width: 700px;
		margin: 0 auto;
	}

	.modal-table {
		margin-top: 40px;
	}

	.modal-disclaimer {
		margin-top: 20px;

		p {
			margin: 0;
			color: ${(props) => props.theme.palette.text.secondary};
		}
	}
`;

const headers = [
	{
		name: '',
		prop: 'a',
	},
	{
		name: 'CO2-Fußabdruck',
		prop: 'b',
	},
	{
		name: 'Energieverbrauch',
		prop: 'c',
	},
	{
		name: 'Energiekosten',
		prop: 'd',
	},
];

const PvAnlageUndBatteriespeicher = ({ data }) => {
	const { without_pv_battery, with_pv_battery } = data.kpis;

	const parsedTableData = [
		{
			a: 'Ohne Batterie',
			b: formatNumberToUnit(without_pv_battery.co2, ' t'),
			c: formatNumberToUnit(without_pv_battery.energy_consumption, ' MWh'),
			d: formatNumberToUnit(without_pv_battery.energy_costs, ' €'),
		},
		{
			a: 'Mit Batterie',
			b: formatNumberToUnit(with_pv_battery.co2, ' t'),
			c: formatNumberToUnit(with_pv_battery.energy_consumption, ' MWh'),
			d: formatNumberToUnit(with_pv_battery.energy_costs, ' €'),
		},
	];

	return (
		<Root>
			<Typography variant="h3">Ihre Analyseauswertung</Typography>
			<div className="modal-content">
				<img src={IconNature} alt="PV-Anlage und Batteriespeicher" />
				<div className="modal-text">
					<Typography variant="h6">PV-Anlage und Batteriespeicher</Typography>
					<Typography>
						Strom aus der Sonne ist unglaublich attraktiv, denn er ist
						kostenlos. Leider ist er nicht immer rund um die Uhr verfügbar.
						Und wenn doch, dann kann es sein, dass man ihn in dem Moment gar
						nicht nutzen kann. Zudem wird die Einspeisung ins Netz finanziell
						auch immer unattraktiver. Ein Batteriespeicher bringt hier die
						Lösung: Denn er kann überschüssigen Strom speichern, um ihn
						jederzeit nutzen zu können, wenn er gebraucht wird.
					</Typography>
					<Typography>
						Bei der Auswertung Ihres Lastgangs haben wir ermittelt, dass Sie
						durch eine PV-Anlage und Batteriespeicher Ihren CO2 Footprint und
						Ihre Netzgebühren signifikant reduzieren können:
					</Typography>
				</div>
			</div>
			<div className="modal-table">
				<TableDefault data={parsedTableData} header={headers} size="small" />
			</div>
			<div className="modal-disclaimer">
				<Typography>
					* Annahme 500g/kWh CO<sup>2</sup> Ausstoß im deutschen Stromnetz.
				</Typography>
				<Typography>
					** Annahme Strompreis von 20 ct/kWh. Passen Sie ihren individuellen
					Strompreis im Portfolio an.
				</Typography>
			</div>
		</Root>
	);
};

export default PvAnlageUndBatteriespeicher;
